import { t } from 'i18next'
import React from 'react'
// @ts-ignore
import video from '../../assets/videos/NotFound.mp4'
import { useAppSelector } from '../../redux/hooks'
import { AuthRoutes } from '../../router/routes'
import { BackButton } from '../util/button/BackButton'
import { LoadingSpinner } from '../util/loading-spinner/LoadingSpinner'

export const NotFoundPage: React.FunctionComponent = () => {
  const notFoundVideo = (
    <>
      <video
        className={'col-12'}
        width="100%"
        style={{ maxHeight: '404px' }}
        autoPlay
        loop
        muted
      >
        <source src={video} type="video/mp4" />
        '404 missing'
      </video>
    </>
  )

  const { loadedBasicInformation } = useAppSelector((state) => state.user)

  return (
    <>
      {!loadedBasicInformation ? (
        <LoadingSpinner />
      ) : (
        <div className={'card p-3'}>
          <h2>{t<string>('title.not_found')}</h2>
          <div
            className={
              'w-full flex flex-wrap justify-content-center align-items-center'
            }
          >
            {notFoundVideo}
            <div className={'w-full col-12 pt-2 secondary-text text-center'}>
              <span>{t<string>('core.not_found_message')}</span>
            </div>
          </div>

          <BackButton
            translationKey={'navigation.to_dashboard'}
            route={AuthRoutes.dashboard}
          />
        </div>
      )}
    </>
  )
}